<template>
  <div class="menu__grid">
    <section class="menu__column">
      <p class="menu__heading">
        Normal & Shape
      </p>
      <BListGroup
        flush
        class="menu__list menu__list--normal"
      >
        <BListGroupItem
          v-if="normalOption"
          button
          class="menu__item menu__item--normal"
          @click="select(normalOption)"
        >
          {{ normalOption.label || normalOption.name }}
        </BListGroupItem>
      </BListGroup>
      <p class="menu__heading">
        {{ shapeGroup?.label ?? 'Shape' }}
      </p>
      <BListGroup
        flush
        class="menu__list"
      >
        <BListGroupItem
          v-for="shape in shapeItems"
          :key="shape.name"
          button
          class="menu__item"
          @click="select(shape)"
        >
          {{ shape.label || shape.name }}
        </BListGroupItem>
      </BListGroup>
    </section>
    <section class="menu__column">
      <div
        v-for="group in secondaryGroups"
        :key="group.name"
        class="menu__group"
      >
        <p class="menu__heading">
          {{ group.label || group.name }}
        </p>
        <BListGroup
          flush
          class="menu__list"
        >
          <BListGroupItem
            v-for="item in buildItems(group)"
            :key="item.name"
            button
            class="menu__item"
            @click="select(item)"
          >
            {{ item.label || item.name }}
          </BListGroupItem>
        </BListGroup>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { BListGroup, BListGroupItem } from "bootstrap-vue-next";
import type { CellTypeMenuOption } from "@/utils/constants/cellTypeMenuConfig";

const props = defineProps<{ options: CellTypeMenuOption[] }>();

const emit = defineEmits<{ (e: "select", option: CellTypeMenuOption): void }>();

const normalOption = computed(() => props.options.find((option) => option.name === "NormalRBC"));
const shapeGroup = computed(() => props.options.find((option) => option.name === "RBCShape"));
const shapeItems = computed(() => shapeGroup.value?.children ?? []);
const secondaryGroups = computed(() =>
  props.options.filter((option) => option.name !== "RBCShape" && option.name !== "NormalRBC"),
);

function buildItems(option: CellTypeMenuOption): CellTypeMenuOption[] {
  if (option.children && option.children.length > 0) {
    return option.children;
  }
  if (option.type === "divider") {
    return [];
  }
  return [option];
}

function select(option: CellTypeMenuOption) {
  emit("select", option);
}
</script>

<style scoped>
.menu__grid {
  display: flex;
  gap: 1rem;
}

.menu__column {
  flex: 1;
  min-width: 0;
}

.menu__heading {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 0.3rem;
}

.menu__group + .menu__group {
  margin-top: 0.75rem;
}

.menu__list {
  width: 240px;
}

.menu__list--normal {
  max-height: none;
  margin-bottom: 0.5rem;
}

.menu__item--normal {
  font-weight: 600;
}

.menu__item {
  cursor: pointer;
  font-size: 1rem;
}
</style>
